import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import ReactHtmlParser from "react-html-parser";
import formStyle from "./position-text.scss";
class PositionTextComponent extends PureComponent {
    render() {
        const { text } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${formStyle.__hash}`,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${formStyle.__hash}` + " " + "position-text-wrapper",
                    children: ReactHtmlParser(text)
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: formStyle.__hash,
                    children: formStyle
                })
            ]
        });
    }
}
export { PositionTextComponent as default };
